/* GRADAZONE — alternar entre la traduccion de una reseña y su texto original.
 *
 * Los dos textos ya vienen en el HTML desde snippets/gz-resena.liquid; aqui solo se cambia
 * cual esta visible. Sin JavaScript se sigue viendo la traduccion, que es lo correcto para
 * quien navega en ingles: esto es una mejora, no un requisito para leer la reseña.
 *
 * Es un ÚNICO listener delegado en el documento, no uno por tarjeta: las reseñas salen 20
 * veces en la ficha de producto y otras 20 en la pagina de opiniones, y ademas el carrusel
 * las mueve. Delegando, da igual cuantas haya ni cuando aparezcan.
 */
(function () {
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-gz-ver]');
    if (!boton) return;
    e.preventDefault();

    var caja = boton.closest('[data-gz-traduccion]');
    if (!caja) return;

    var traducido = caja.querySelector('[data-gz-traducido]');
    var original = caja.querySelector('[data-gz-original]');
    var etiqueta = caja.querySelector('[data-gz-etiqueta]');
    var punto = caja.querySelector('[data-gz-punto]');
    if (!traducido || !original) return;

    var viendoOriginal = original.classList.contains('is-visible');

    traducido.classList.toggle('is-visible', viendoOriginal);
    original.classList.toggle('is-visible', !viendoOriginal);

    // la etiqueta "Translated" solo tiene sentido mientras se ve la traduccion
    var ocultar = !viendoOriginal;
    if (etiqueta) etiqueta.hidden = ocultar;
    if (punto) punto.hidden = ocultar;
    boton.textContent = viendoOriginal ? boton.dataset.verOriginal : boton.dataset.verTraduccion;
  });
})();
